import { useEffect, useState } from "react";
import useDefaultCRUDHandlers from "../../../../hooks/useDefaultCRUDHandlers";
import { ILead } from "../../../../models/Lead";
import useMessages from "../../../../data/useMessages";
import classNames from "../../../../utils/classNames";



export default function LeadUnreadMessage({ 
  lead,
  small
}: { 
  lead: ILead,
  small?: boolean
}) {
  // const { update } = useSingleLead(lead.id);
  const { unreadMessages } = useMessages();
  const { saveHandlers } = useDefaultCRUDHandlers("Leads");
  const [currentMessageCount, setCurrentMessageCount] = useState<number>();

  const messages   = small ? "font-semibold bg-blue-100 text-blue-600 rounded-full" : "font-semibold text-lg bg-blue-100 text-blue-600 rounded-full";
  const noMessages = small ? "text-gray-400" : "";
  const baseStyle  = small ? "w-6 h-6 text-xs" : "w-10 h-10 text-sm";

  useEffect(() => {
    if (!unreadMessages.isLoading && unreadMessages.data) {
      setCurrentMessageCount(unreadMessages.data.data.find(m => m.leadId === lead.id)?.unreadMessageCount);
    }
  }, [unreadMessages.isLoading, unreadMessages.data, lead])

  return (
    <div className="flex justify-center items-center">
      {currentMessageCount && (
        <span
          className={classNames(currentMessageCount > 0 ? messages : noMessages,
            `flex items-center justify-center text-center ${baseStyle}`)}>
          {currentMessageCount}
        </span>
      )}
    </div>
  )
}
